"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImgBlock = void 0;
const React = require("react");
const react_1 = require("react");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const CircularIcon_1 = require("../CircularIcon");
const colors_1 = require("../../../../types/colors");
const styles = require("./styles.scss");
const ImageModal_1 = require("../ImageModal");
const css = (0, cssComposer_1.default)(styles, "ImgBlock");
/**
 * Displays an image within a placeholder space. The size is defined by the class applied.
 */
const ImgBlock = ({ className, variant = "cover", style = {}, size = "", square = false, children, src, alt, zoomable, onClick }) => {
    const img = (0, react_1.useRef)();
    const [loaded, setLoaded] = (0, react_1.useState)();
    const [enlarge, setEnlarge] = (0, react_1.useState)(false);
    (0, react_1.useLayoutEffect)(() => {
        if (!img.current)
            return;
        img.current.onload = () => {
            setLoaded(true);
        };
    }, []);
    const imgStyle = { backgroundImage: `url('${src}')` };
    return (React.createElement(React.Fragment, null,
        React.createElement(ImageModal_1.ImageModal, { src: !!enlarge && src, alt: alt, onClose: () => setEnlarge(false) }),
        React.createElement("div", { className: css("", `-size-${size}`, `-${variant}`, {
                "-square": square,
                "-zoomable": zoomable,
                className
            }), onClick: () => zoomable ? setEnlarge(true) : onClick ? onClick() : false, style: style, "data-test": "img-block-wrapper", "data-test-is-square": square },
            !loaded ? (React.createElement("img", { src: src, ref: img })) : (React.createElement("div", { className: css("img"), style: imgStyle, "data-test": "img-block" })),
            !!children && React.createElement("div", { className: css("overlayContent") }, children),
            !!zoomable && (React.createElement("div", { className: css("zoomable") },
                React.createElement(CircularIcon_1.default, { name: "enlarge2", variant: colors_1.TColorVariants.Info }))))));
};
exports.ImgBlock = ImgBlock;
//# sourceMappingURL=index.js.map